import { ItemsT } from 'baseui/menu';

export const TYPE = 'question';
export const PROMPT = 'delete';
export const PROMPT_DESCRIPTION = 'Deleting a question will also delete the answers attached to it.';

export const MENU_ITEMS: ItemsT = [
  {
    label: 'Change Question Number',
  },
  {
    label: 'Delete Question',
  },
];
